module.exports = __webpack_public_path__ + "img/signable_white_raster.d35aa760.png";